<template>
  <div id="app">
    <loading-spinner :loading="isLoading" />
    <app-header />
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <app-footer />
  </div>
</template>

<script>
import { ref, provide } from 'vue'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import LoadingSpinner from './components/LoadingSpinner.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    LoadingSpinner
  },
  setup() {
    const isLoading = ref(true)
    const emitLoadingComplete = () => {
      window.dispatchEvent(new Event('loading-complete'))
    }
    
    provide('isLoading', isLoading)
    
    // 模拟页面加载
    setTimeout(() => {
      isLoading.value = false
      emitLoadingComplete()
    }, 1000)
    
    return {
      isLoading
    }
  },
  watch: {
    $route() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.$root.$emit('loading-complete');
      }, 800)  // 路由切换时的加载时间改为0.8秒
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  background: linear-gradient(135deg, #1a2a6c 0%, #b21f1f 50%, #fdbb2d 100%);
  background-attachment: fixed;
  overflow-x: hidden;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #ffffff;
  line-height: 1.6;
  min-height: 100vh;
  transition: background 0.3s ease;
  position: relative;
  overflow-x: hidden;
}

body::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'><circle cx='60' cy='60' r='50' stroke='rgba(255,255,255,0.15)' stroke-width='1' fill='none' /></svg>");
  opacity: 0.4;
  pointer-events: none;
  z-index: -1;
  animation: pulse 3s infinite alternate;
}

@keyframes pulse {
  0% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.6;
  }
}

#app {
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: transparent;
  color: #ffffff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.main-content {
  flex: 1;
  padding-top: 70px;
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

img {
  max-width: 100%;
}

a {
  color: #ffffff;
  text-decoration: none;
}

/* Element Plus主题自定义 */
:root {
  --el-color-primary: #fdbb2d;
  --el-button-hover-border-color: #fdbb2d;
  --el-button-active-border-color: #fdbb2d;
}

.el-button {
  border: none !important;
  font-weight: 600 !important;
}

.el-button--primary {
  background: linear-gradient(45deg, #000000, #434343) !important;
}

.el-button--success {
  background: linear-gradient(45deg, #11998e, #38ef7d) !important;
}

/* 全局动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* 全局卡片悬浮效果 */
.hover-card {
  transition: all 0.3s ease;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.hover-card:hover {
  transform: translateY(-5px) translateZ(0);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

/* 全局按钮动画 */
.el-button {
  transition: all 0.3s ease !important;
  position: relative !important;
  overflow: hidden !important;
}

.el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

/* 全局图标动画 */
.el-icon {
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.el-icon:hover {
  transform: scale(1.1);
}

/* 全局链接动画 */
a {
  position: relative;
  transition: color 0.3s ease;
}

a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: currentColor;
  transition: width 0.3s ease;
}

a:hover::after {
  width: 100%;
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 60px;
  }
  
  .el-button {
    width: 100% !important;
    margin: 5px 0 !important;
  }
}
</style>
